import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LOGO_URL = '/logo.svg';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await signIn(email, password);
      navigate('/calendar');
    } catch (err: any) {
      setError(err.message || 'Failed to sign in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--color-background)',
      backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(217, 178, 86, 0.06) 0%, transparent 50%)',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '420px',
        padding: 'var(--spacing-6)',
      }}>
        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-10)' }}>
          <img
            src={LOGO_URL}
            alt="Bling Bling Brisbane"
            style={{ height: '72px', marginBottom: 'var(--spacing-4)' }}
          />
          <p style={{
            color: 'var(--color-accent)',
            fontFamily: 'var(--font-family-heading)',
            fontSize: 'var(--font-size-sm)',
            textTransform: 'uppercase',
            letterSpacing: '0.25em',
            fontWeight: 600,
          }}>
            Admin Portal
          </p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} style={{
          backgroundColor: 'var(--color-surface)',
          padding: 'var(--spacing-8)',
          borderRadius: 'var(--radius-xl)',
          border: '1px solid var(--color-border)',
          boxShadow: 'var(--shadow-lg)',
        }}>
          <div style={{ marginBottom: 'var(--spacing-5)' }}>
            <label style={{
              display: 'block',
              fontSize: 'var(--font-size-xs)',
              fontWeight: '600',
              marginBottom: 'var(--spacing-2)',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: 'var(--color-text-muted)',
            }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="admin@blingbling.com.au"
              style={{
                width: '100%',
                padding: 'var(--spacing-3) var(--spacing-4)',
                backgroundColor: 'var(--color-surface-elevated)',
                border: '1px solid var(--color-border)',
                borderRadius: 'var(--radius-default)',
                color: 'var(--color-text)',
                fontSize: 'var(--font-size-base)',
              }}
            />
          </div>

          <div style={{ marginBottom: 'var(--spacing-6)' }}>
            <label style={{
              display: 'block',
              fontSize: 'var(--font-size-xs)',
              fontWeight: '600',
              marginBottom: 'var(--spacing-2)',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: 'var(--color-text-muted)',
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: 'var(--spacing-3) var(--spacing-4)',
                backgroundColor: 'var(--color-surface-elevated)',
                border: '1px solid var(--color-border)',
                borderRadius: 'var(--radius-default)',
                color: 'var(--color-text)',
                fontSize: 'var(--font-size-base)',
              }}
            />
          </div>

          {error && (
            <p style={{
              color: 'var(--color-error)',
              fontSize: 'var(--font-size-sm)',
              marginBottom: 'var(--spacing-4)',
              textAlign: 'center',
              padding: 'var(--spacing-2) var(--spacing-3)',
              backgroundColor: 'rgba(224, 85, 85, 0.1)',
              borderRadius: 'var(--radius-default)',
            }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 'var(--spacing-3) var(--spacing-4)',
              backgroundColor: 'var(--color-accent)',
              border: 'none',
              borderRadius: 'var(--radius-default)',
              color: '#1e1e1e',
              fontSize: 'var(--font-size-base)',
              fontWeight: '600',
              fontFamily: 'var(--font-family-heading)',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              boxShadow: 'var(--shadow-sm)',
            }}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        {/* Footer */}
        <p style={{
          textAlign: 'center',
          marginTop: 'var(--spacing-8)',
          fontSize: 'var(--font-size-xs)',
          color: 'var(--color-text-muted)',
        }}>
          &copy; {new Date().getFullYear()} Bling Bling Brisbane. All Rights Reserved.
        </p>
      </div>
    </div>
  );
}
